import { ApiSite, ApiSiteClient, ApiSiteInfo, ApiSiteInfoTypes, ApiSiteStat } from './apiTypes'
import { DestinationMapperEntity } from '~/passporter-services/destination/toEntity'
import { SiteInfo2, SITE_INFO_TYPE } from '~/models/SiteInfo'
import { LinkEntityMapper } from '~/passporter-services/link/entityMapper'
import { Site2 as Site, ClientSite, Stat } from '~/models/Site'

export class SiteEntityMapper {
	static toSite = (apiSite: ApiSite): Site => {
		const destination = DestinationMapperEntity.toDestination(apiSite.destination)
		const site: Site = {
			id: apiSite.id,
			description: apiSite.description,
			views: apiSite.num_views,
			hasContent: apiSite.has_content,
			destination,
			isOficial: !!apiSite.client,
			subdomain: apiSite.subdomain,
		}
		if (apiSite.client) site.client = this.toClient(apiSite.client)
		if (apiSite.stats) site.stats = this.toStats(apiSite.stats)

		return site
	}

	private static toClient = (apiClient: ApiSiteClient): ClientSite => {
		const client: ClientSite = {
			userId: apiClient.user_id,
			name: apiClient.name,
			image: apiClient.picture_url,
		}
		return client
	}

	private static toStats = (apiStats: ApiSiteStat[]): Stat[] => {
		const stats: Stat[] = apiStats.map((stat) => {
			return {
				id: stat.id,
				name: stat.name,
				iconUrl: stat.icon_url,
				percentage: stat.percentage.toString(),
			}
		})
		return stats
	}

	static toInfo = (info: ApiSiteInfo): SiteInfo2 => {
		const parsed: SiteInfo2 = {
			id: info.id,
			title: info.title,
			type: this.toInfoType(info.type),
			summary: info.summary,
			description: info.description,
			icon: info.icon_url,
		}
		if (info.links) parsed.links = LinkEntityMapper.toLinks(info.links)
		return parsed
	}

	static toInfos = (siteInfos: ApiSiteInfo[]): SiteInfo2[] => {
		return siteInfos.map((siteInfo) => this.toInfo(siteInfo))
	}

	private static toInfoType(type: ApiSiteInfoTypes): SITE_INFO_TYPE | undefined {
		const correlation = {
			documentation: SITE_INFO_TYPE.DOCUMENTATION,
			money: SITE_INFO_TYPE.MONEY,
			gastronomy: SITE_INFO_TYPE.GASTRONOMY,
			transport: SITE_INFO_TYPE.TRANSPORT,
			climate: SITE_INFO_TYPE.CLIMATE,
			health_and_safety: SITE_INFO_TYPE.HEALTH_AND_SAFETY,
			connectivity: SITE_INFO_TYPE.CONNECTIVITY,
			culture: SITE_INFO_TYPE.CULTURE,
			souvenirs: SITE_INFO_TYPE.SOUVENIRS,
		}

		const matched = correlation[type]
		return matched
	}
}
